let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aUU4w")).then(() => parcelRequire('22iKv'));